import { Component, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-page-explanation-platform',
    templateUrl: './page-explanation-platform.component.html',
    styleUrls: ['./page-explanation-platform.component.scss'],
    standalone: false
})
export class PageExplanationPlatformComponent implements OnInit {

  constructor(public translate: TranslateService) {



  }

  ngOnInit(): void {
  }

}
